// extracted by mini-css-extract-plugin
export default {"titleWrap":"O2uBqM"};